import queryString from 'query-string';

// Returns dictionary from query string with simple object for each key
export const getSimpleQueryDict = (query) => {
  const queryPairs = query.split('&');
  const queryDict = {};
  queryPairs.forEach((pair) => {
    const pairSplit = pair.split('=');
    queryDict[pairSplit[0]] = decodeURIComponent(pairSplit[1] || '');
  });
  return JSON.parse(JSON.stringify(queryDict));
}

export const queryDictToString = (queryDict) => {
  let result = '';
  if (queryDict) {
    result = queryString.stringify(queryDict, { skipNull: true });
  }
  return result ? `?${result}` : '';
}

export const getCardSendId = (queryDict) => {
  let cardSendId = null;
  if (queryDict?.magicLink) {
    cardSendId = queryDict.magicLink;
  }
  if (!cardSendId && queryDict?.card_send_id) {
    cardSendId = queryDict.card_send_id;
  }
  if (Array.isArray(cardSendId)) {
    if (cardSendId.length > 0) {
      cardSendId = cardSendId[0];
    } else {
      cardSendId = null;
    }
  }
  return cardSendId;
}